import { z } from 'zod';
import { ProvenanceSchema } from './provenance.js';

/**
 * @aiPurpose agent verdict block emitted at the end of a multi-source
 *   reconciliation run. Carries the outcome, confidence, and provenance
 *   that back the answer so the UI can render a trust indicator and an
 *   expandable evidence trail.
 * @aiInvariant `outcome: 'agreed'` means all sources produced the same
 *   value; `'reconciled'` means the agent selected the authoritative value
 *   after reviewing differing sources; `'discrepancy'` means sources
 *   disagreed and no definitive answer could be reached. `candidates` is
 *   populated when more than one source was consulted and `outcome` is
 *   `'reconciled'` or `'discrepancy'`.
 */
export const AgentVerdictSchema = z
  .object({
    outcome: z.enum(['agreed', 'reconciled', 'discrepancy']),
    confidence: z.enum(['high', 'low']),
    rounds: z.number().int(),
    basis: ProvenanceSchema,
    candidates: z.array(ProvenanceSchema).optional(),
  })
  .strict();

export type AgentVerdict = z.infer<typeof AgentVerdictSchema>;
